// extracted by mini-css-extract-plugin
module.exports = {"app":"Home_app__1Ni0y","startPageMain":"Home_startPageMain__3YN5k","startPageHead":"Home_startPageHead__1zAY1"};